import { render, staticRenderFns } from "./ArrearsExerciseNew.vue?vue&type=template&id=70bea35a&scoped=true"
import script from "./ArrearsExerciseNew.vue?vue&type=script&lang=js"
export * from "./ArrearsExerciseNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bea35a",
  null
  
)

export default component.exports